var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDropUp48Filled = function SvgIconArrowDropUp48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.9 24.53-4.79-5.06a3 3 0 0 0-2.11-.9 2.912 2.912 0 0 0-2.1.9l-4.8 5.06a2.9 2.9 0 0 0 2.1 4.9h9.6a2.9 2.9 0 0 0 2.1-4.9Z",
    fill: "current"
  })));
};
export default SvgIconArrowDropUp48Filled;